import ApiClient from './ApiClient';

// Navigation folders for the Tables module (one level). Deleting a folder
// ungroups its tables server-side; it never deletes them.
class TableFoldersAPI extends ApiClient {
  constructor() {
    super('table_folders', { accountScoped: true });
  }
}

export default new TableFoldersAPI();
